<template>
  <Breadcrumbs
      title="Order Request History"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Order Request History', path: '/order-request-history' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <orderHistoryForm/>
    </div>
  </div>
</template>

<script>

import orderHistoryForm from './orderRequestHistoryForm.vue'
export default {
  name: 'indexList',
  components: {

    orderHistoryForm,

  },


}

</script>
